import React, { useState } from "react";
import { ColumnDirective, Grid, ColumnsDirective, Resize, GridComponent, Inject, Page, Sort, Filter, Group } from '@syncfusion/ej2-react-grids';
import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import useSave from "../../Hooks/useSave";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import useValidateRole from "../../Hooks/useValidateRole";
import Select from "react-select";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
const EmailTemplates = (props) => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [view, setview] = useState(false);
    const [update, setUpdate] = useState(false);
    const [PageRole, setPageRole] = useState("Email Templates");
    const url = "api/EmailTemplates";
    const dataurl = process.env.REACT_APP_BASE_URL + 'api/EmailTemplates/AllEmails';
    let grid = Grid | null;

    const handleOpenModal = (event) => {
        //event.persist();
        setInputs({});
        setOpen(true);
    };

    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };
    const handleSelectChange = (UserGroup, actionMeta) => {
        setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
    };
    const handleEdit = () => {
        if (inputs.id) {
            setOpen(true);
            setUpdate(true);
            setview(false);
        } else {
            alert("Select a record to edit");
        }
    };
    const handleView = () => {
        if (inputs.id) {
            setview(true);
            setUpdate(false);
            setOpen(true);
        } else {
            alert("Select a record to veiw");
        }
    };
    const handleSelect = (k, event) => {

        setInputs(k.data);
    };
    const handleCloseModal = () => {

        setOpen(false);
        setview(false);
        setUpdate(false);
        setInputs({});
    };
    const HandleSave = () => {
        useSave(url, inputs);
        grid.refresh();
    };
    const HandleUpdate = () => {
        useUpdate(url + "/" + inputs.id, inputs);
        grid.refresh();
    };
    const HandleSubmit = (event) => {
        event.preventDefault();
        if (update) {
            HandleUpdate();
        } else {
            HandleSave();
        }

        handleCloseModal();
    };
    const CallDeletehook = () => {
        useDelete(url + "/" + inputs.id);
        grid.refresh();
    };
    const HandelDelete = () => {
        if (inputs.id) {
            CallDeletehook();
            grid.refresh();
        } else {
            alert("Select a record to delete");
        }

    };

    const ActionsBtn = () => {
        return (
            <div>
                {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-primary p-2"
                        type="button"
                        onClick={handleEdit}
                    >
                        Update
                    </button>
                ) : null}
                &nbsp; &nbsp;
                {useValidateRole(PageRole, "Remove") ? (
                    <button onClick={HandelDelete} className="btn btn-danger p-2">
                        Delete
                    </button>
                ) : null}
                &nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
                </button>
            </div>
        );
    };
    const CategoryOptions = [
        {
            value: "Capitation Request Opened",
            label: "Capitation Request Opened",
        },
        {
            value: "Capitation Request Received",
            label: "Capitation Request Received",
        },
        {
            value: "Capitation Request Approved",
            label: "Capitation Request Approved",
        }, {
            value: "Capitation Request Declined and Sent Back",
            label: "Capitation Request Declined and Sent Back",
        }, {
            value: "Capitation Request Declined and Closed",
            label: "Capitation Request Declined and Closed",
        }, {
            value: "Capitation Paid",
            label: "Capitation Paid",
        },
        {
            value: "Notify Student",
            label: "Notify Student",
        },
        {
            value: "Notify Approver",
            label: "Notify Approver",
        }
    ];
    return (
        <div id="content" className="content">
            <ol class="breadcrumb float-xl-right">
                <li class="breadcrumb-item">
                    {" "}
                    <Link to="/">Home </Link>{" "}
                </li>
                <li class="breadcrumb-item active">Email Templates</li>
            </ol>
            <h1 class="page-header mb-3">Email Templates</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div class="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
                        {useValidateRole(PageRole, "AddNew") ? (
                            <button
                                onClick={handleOpenModal}
                                className="btn btn-primary p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; New &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "View") ? (
                            <button
                                onClick={handleView}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; View &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Edit") ? (
                            <button
                                onClick={handleEdit}
                                className="btn btn-info p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Edit &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Remove") ? (
                            <button
                                onClick={HandelDelete}
                                className="btn btn-danger p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Delete &nbsp;
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <GridComponent ref={g => grid = g}
                            allowPaging={true}
                            allowResizing={true}
                            allowTextWrap={true}
                            allowFiltering={true}
                            rowSelected={(args) => {
                                handleSelect(args);
                            }}
                            dataSource={new DataManager({
                                adaptor: new UrlAdaptor(),
                                crossDomain: true,
                                url: dataurl,
                                headers: [{
                                    Authorization: "Bearer " + window.sessionStorage.getItem("xtoken")
                                }]
                            })
                            }>
                            <ColumnsDirective>
                                <ColumnDirective field='id' headerText='id' visible={false} />
                                <ColumnDirective field='category' width='90' headerText='Category' />
                                <ColumnDirective field='subject' width='100' headerText='Subject' />
                                <ColumnDirective field='body' headerText='Body' />
                            </ColumnsDirective>
                            <Inject services={[Page, Sort, Resize, Filter]} />
                        </GridComponent>
                    </div>
                </div>
            </div>

            <Modal visible={open} width="80%" height="65%" effect="fadeInUp">
                <div style={{ "overflow-y": "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
                    </a>

                    <div className="row">
                        <div className="col-sm-5"></div>
                        {view ? null : (
                            <div className="col-sm-4 fontWeight-bold text-blue">
                                Email Templates
                            </div>
                        )}
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />

                                {view ? (
                                    <div>
                                        <h3>Email Templates</h3>
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">category:</td>
                                                    <td>{inputs.category}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Subject:</td>
                                                    <td>{inputs.subject}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Body:</td>
                                                    <td>{inputs.body}</td>
                                                </tr>

                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", "justify-content": "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                                        <div className=" row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label
                                                        htmlFor="Datereceived"
                                                        className="fontWeight-bold"
                                                    >
                                                        category
                                                    </label>
                                                    <Select
                                                        name="category"
                                                        value={CategoryOptions.filter(
                                                            (option) => option.value === inputs.category
                                                        )}
                                                        //defaultInputValue={inputs.securityGroupId}
                                                        onChange={handleSelectChange}
                                                        options={CategoryOptions}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label
                                                        htmlFor="Datereceived"
                                                        className="fontWeight-bold"
                                                    >
                                                        subject
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="subject"
                                                        required
                                                        value={inputs.subject}
                                                        onChange={handleInputChange}

                                                    // defaultvalue={inputs.name}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className=" row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label
                                                        htmlFor="Datereceived"
                                                        className="fontWeight-bold"
                                                    >
                                                        Body
                                                    </label>
                                                    <CKEditor
                                                        editor={ClassicEditor}
                                                        data={inputs.body ? inputs.body : ""}
                                                        onChange={(event, editor) => {
                                                            const data = editor.getData();
                                                            setInputs((inputs) => ({ ...inputs, body: data }));

                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", "justify-content": "flex-end" }}>
                                            <div class="d-flex flex-row">
                                                {update ? (
                                                    <button
                                                        className="btn btn-primary p-2"
                                                        type="submit"
                                                    >
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="btn btn-primary p-2"
                                                        type="submit"
                                                    >
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default EmailTemplates;
